import React from 'react';
import web_img from '../images/web.svg';
import app_img from '../images/app.svg';
import custom_software_development from '../images/custom_software_development.svg';
import hosting from '../images/hosting.svg';
import consultation from '../images/consultation.svg';
import digital_marketing from '../images/digital-marketing.svg';
const Services = () => {
    return (
        <section id="services" className="services-section py-5">
            <div className="container" data-aos="fade-up">
                {/* Header */}
                <div className="text-center mb-5">
                    <h2 className="section-title fw-bold">Our Services</h2>
                    <p className="section-subtitle text-muted">
                        Empowering businesses with end-to-end technology solutions crafted for innovation, scalability, and impact.
                    </p>
                </div>

                {/* Service Cards */}
                <div className="row g-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="service-card text-center h-100 p-4 shadow-sm">
                            <img alt="Web Development" src={web_img} className="mb-3 service-icon" />
                            <h3 className="service-heading">Web Development</h3>
                            <p className="text-muted">
                                We build fast, scalable, and secure web applications that deliver powerful digital experiences and business growth.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="service-card text-center h-100 p-4 shadow-sm">
                            <img alt="Mobile App Development" src={app_img} className="mb-3 service-icon" />
                            <h3 className="service-heading">Mobile App Development</h3>
                            <p className="text-muted">
                                Our mobile experts design and develop stunning, high-performance apps for iOS, Android, and cross-platform ecosystems.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="service-card text-center h-100 p-4 shadow-sm">
                            <img alt="Custom Software Development" src={custom_software_development} className="mb-3 service-icon" />
                            <h3 className="service-heading">Custom Software Development</h3>
                            <p className="text-muted">
                                We create tailor-made software solutions aligned with your goals - ensuring efficiency, innovation, and scalability.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="service-card text-center h-100 p-4 shadow-sm">
                            <img alt="Cloud Solutions" src={hosting} className="mb-3 service-icon" />
                            <h3 className="service-heading">Cloud Solutions</h3>
                            <p className="text-muted">
                                Our secure, scalable cloud solutions help businesses innovate faster, scale smarter, and achieve digital transformation.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="service-card text-center h-100 p-4 shadow-sm">
                            <img alt="IT Consulting" src={consultation} className="mb-3 service-icon" />
                            <h3 className="service-heading">IT Consulting</h3>
                            <p className="text-muted">
                                Our experts guide you with data-driven insights and strategies to align technology with your long-term business objectives.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="service-card text-center h-100 p-4 shadow-sm">
                            <img alt="Digital Marketing" src={digital_marketing} className="mb-3 service-icon" />
                            <h3 className="service-heading">Digital Marketing</h3>
                            <p className="text-muted">
                                We help you connect, engage, and convert audiences through smart, ROI-driven digital marketing strategies.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Services;
